import { useEffect } from 'react';
import { useLocaleCatalog } from '../api/queries';
import { useLocale } from './locale';

/**
 * Dil kataloğunu bir kez yükler ve store'a yazar (SEOAI-78 incelemesi).
 *
 * Korumasız uçtan okunur: kullanıcı giriş yapmadan da dil seçebilmeli. Katalog
 * gelmezse panel çalışmaya devam eder — başlangıç dili saklanan/tarayıcı
 * dilidir; yalnızca seçici gizli kalır.
 */
export function LocaleCatalogLoader() {
  const catalog = useLocaleCatalog();
  const applyCatalog = useLocale((s) => s.applyCatalog);

  useEffect(() => {
    if (catalog.data) applyCatalog(catalog.data);
  }, [catalog.data, applyCatalog]);

  return null;
}
